import { defineMessages } from "@formatjs/intl";

export const messages = defineMessages({
  apartmentVisitsLabel: {
    id: "Rooms.ApartmentVisits.Label",
    defaultMessage: "Apartment visits: ",
    description: "The label of the apartment visits",
  },
  apartmentVisitsNow: {
    id: "Rooms.ApartmentVisits.Now",
    defaultMessage: "Available now",
    description: "The value of the apartment visits",
  },
  apartmentVisitsDate: {
    id: "Rooms.ApartmentVisits.Date",
    defaultMessage: "From {month} {day}, {year}",
    description: "The value of the apartment visits",
  },
  availableFromLabel: {
    id: "Rooms.AvailableFrom.Label",
    defaultMessage: "Available from: ",
    description: "The label of the available from",
  },
  availableFromNow: {
    id: "Rooms.AvailableFrom.Now",
    defaultMessage: "Immediately",
    description: "The value of the available from",
  },
  availableFromDate: {
    id: "Rooms.AvailableFrom.Date",
    defaultMessage: "{month} {day}, {year}",
    description: "The value of the available from",
  },
  informationDate: {
    id: "Rooms.InformationDate",
    defaultMessage: "*Information as of {month}/{day}/{year}.",
    description: "Information date for the apartment",
  },
});

export default messages;
